<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <v-breadcrumbs>
            <v-breadcrumbs-item>
              <router-link to="/">Home</router-link>
            </v-breadcrumbs-item>
            <span class="divider">></span>
            <v-breadcrumbs-item disabled>
              Partners
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-col>
      </v-row>
      <v-row no-gutters class="px-5">
        <v-col cols="12">
            <h1>Partners</h1>

            <v-row no-gutters>
                <v-col cols="3" class="pe-4 pb-4">
                    <v-card class="px-3 py-5 text-center">
                        <v-img src="@/assets/mbks-logo.png" aspect-ratio="1.5"></v-img>
                        <v-card-title>MBKS</v-card-title>
                    </v-card>
                </v-col>
                <v-col cols="3" class="pe-4 pb-4">
                    <v-card class="px-3 py-5 text-center">
                        <v-img src="@/assets/dbku-logo.jpeg" aspect-ratio="1.5"></v-img>
                        <v-card-title>DBKU</v-card-title>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'AboutPage'
};
</script>
